export default {
  changeCity (state, city) {
    state.city = city
    try {
      localStorage.city = city
    } catch (e) {}
  },
  
  changeUserInfo (state, userInfo) {
    state.userInfo = userInfo
  },

  SET_USERINFO(state,userInfo){
    state.userInfo = userInfo
  },

  //添加
  getReceiveData(state,e){
    state.receiveData=state.receiveData.filter(res=>{
      return res.id !== e.id
    })
    state.receiveData.push(e)
  },

  // 删除
  delReceiveData(state,e){
    state.receiveData = state.receiveData.filter((res)=>{
      return res.id !==e
    })
  },

  setTodo(state, e) {
    if (!e) return
    sessionStorage.setItem('todo', JSON.stringify(e))
    state.todoDesc = e.desc
    state.todoTitle = e.title
    state.todos = e.documentList || []
  },

  setUndoneTodoLength (state, e) {
    if (!e) return
    sessionStorage.setItem('unDoneLength', e)
    state.unDoneLength = e
  }

  // //计算
  // sumPrice(state,e){
  //   state.receiveData.forEach(element => {
  //     console.log()
  //   });
  // }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js